import React from 'react'
import { useSelector } from 'react-redux';
import * as Icon from 'react-bootstrap-icons';

import { Forbidden } from '../../components';

import styles from './Suscripcion.module.css';
import { colors, roles } from '../../types/types';

export const Suscripcion = () => {

  const { user } = useSelector(state => state.auth);

  return (user.rol === roles.MEDICO) ? (
    <div className={styles.container}>
      <div className={styles.graficContainer}><Icon.BookmarkStar color={colors.PRIMARY} size={100} /></div>
      <div className={styles.principal}>Suscripción caduca</div>
      <div className={styles.secundario}>Contacta con el equipo de soporte para renovar tu suscripción</div>
    </div>
  ) : <div className='mt-3'><Forbidden /></div>
}
